// La sesión ha expirado y necesita una nueva clave par.
export const UUID_EXPIRED = 'C401000101';

// Error genérico de credenciales inválidas. No cuenta como intento.
export const USER_INVALID_CRED = 'C4010000';

// Usuario y/o contraseña incorrectos. Cuenta como intento.
export const USER_NOT_FOUND = 'C401000201';

// Usuario sin aplicaciones en assisted-channels
export const USER_NOT_APPLICATIONS = 'C4040000';

// El usuario será temporalmente bloqueado.
export const USER_WILL_BE_TEMP_BLOCKED = 'C401000202';

// El usuario ha sido temporalmente bloqueado.
export const USER_WAS_TEMP_BLOCKED = 'C401000203';

// El usuario será bloqueado.
export const USER_WILL_BE_PERMANENTLY_BLOCKED = 'C401000204';

// El usuario ha sido bloqueado.
export const USER_WAS_PERMANENTLY_BLOCKED = 'C401000205';

// El token de usuario recordado no es válido o lo era pero ha caducado.
export const REMEMBER_TOKEN_INVALID = 'C401000207';

// La petición no es válida porque requiere subida de nivel se la sesión.
export const SCA_REQUIRED = 'C403000003';

// Se requiere una clave única para poder continuar.
// La clave única se ha enviado al teléfono del cliente.
export const OTP_REQUIRED = 'C403000001';

// La clave única enviada no es válida.
export const OTP_INVALID = 'C403000101';

// Se ha recibido OTP_INVALID 3 veces y tras el aviso, se ha vuelto intentar la OTP fallando nuevamente.
export const OTP_LAST_CHANCE = 'C403000105';

// El usuario ha pedido una nueva clave única
export const OTP_RENEWED = 'C403000103';

// La clave única enviada ha expirado (expira en dos minutos).
export const OTP_EXPIRED = 'C403000102';

// Error al validar la clave única. Este código suele salir al tercer intento.
// Probablemente el usuario ha sido bloqueado.
export const OTP_ERROR = 'C403000002';

//El usuario no disponible de un teléfono móvil para la realización del restablecimiento de contraseña.
export const OTP_NO_TELEPHONE_ERROR = 'C400000205';

//El usuario no se encuentra activo para la realización del restablecimiento de contraseña.
export const OTP_NO_ACTIVE_USER_ERROR = 'C400000206';

// Para realizar dicha operación es necesario que el usuario introduzca el código enviado por email.
export const OTP_EMAIL_CODE = 'C403000106';

// El servidor no ha respondido en el tiempo establecido.
export const REQUEST_TIMEOUT = 'ECONNABORTED';

// Beneficiario (de envio) no encontrado. El teléfono no está registrado en bizum.
export const BIZUM_DESTINATION_NOT_FOUND = 'C400000004';

// Beneficiario (de solicitud) no encontrado. El teléfono no está registrado en bizum.
export const BIZUM_ISSUER_NOT_FOUND = 'C400000005';

// Beneficiario no encontrado y con una solicitud de invitación pendiente.
export const BIZUM_DESTINATION_IS_PENDING = 'C400000012';

// Importe superior al límite máximo.
export const BIZUM_MAX_LIMIT = 'C400000006';

// Importe inferior al límite mínimo.
export const BIZUM_MIN_LIMIT = 'C400000007';

// Se ha superado el importe máximo por día.
export const BIZUM_DAILY_AMOUNT_LIMIT = 'C400000008';

// Se ha superado el número de operaciones máximas por día.
export const BIZUM_DAILY_LIMIT = 'C400000009';

// Se ha superado el número de operaciones máximas de envíos al mes.
export const BIZUM_SEND_MONTHLY_LIMIT = 'C400000010';

// Se ha superado el número de operaciones máximas de solicitudes al mes.
export const BIZUM_REQUEST_MONTHLY_LIMIT = 'C400000013';

// Saldo disponible insuficiente.
export const BIZUM_NO_AVAILABLE_BALANCE = 'C400000019';

// Se ha superado el tiempo límite para confirmar la operación.
export const BIZUM_TIMEOUT = 'C408000001';

// No se genera firma en el representante
export const ERROR_SIGNATURE_NOT_GENERATED_MINOR = 'C409000002';

// Se ha superado el saldo disponible en la cuenta para realizar la operación.
export const BIZUM_BALANCE_LIMIT = 'C400000011';

// Se ha superado el número de intentos máximos para la portabilidad
export const BIZUM_OTP_ERROR = 'C403000104';

// El teléfono destino es el mismo que el teléfono emisor.
export const BIZUM_DESTINATION_PHONE_NOT_VALID = 'C412000003';

// El teléfono del usuario ya se encuentra registrado en bizum.
export const BIZUM_PHONE_ALREADY_EXISTS = 'C412000001';

// El email del usuario ya se encuentra registrado en bizum.
export const BIZUM_EMAIL_ALREADY_EXISTS = 'C412000002';

// No se ha podido incluir el texto y/o imagen a la operación.
export const BIZUM_ERROR_ADDITIONAL_CONTENT_TYPE1 = 'C200000000';
export const BIZUM_ERROR_ADDITIONAL_CONTENT_TYPE2 = 'C200000001';
export const BIZUM_ERROR_ADDITIONAL_CONTENT_TYPE3 = 'C200000002';
export const BIZUM_ERROR_ADDITIONAL_CONTENT_TYPE4 = 'C200000003';
export const BIZUM_ERROR_ADDITIONAL_CONTENT_TYPE5 = 'C200000004';

// Error generico de RSI
export const RSI_GENERIC_ERROR = 'C500000000';

// La operativa on está disponible
export const BIZUM_ERROR_OPERATIVE_NOT_AVAILABLE = 'C500000011';

// El usuario no está bloqueado por número de intentos fallidos
export const USER_NOT_PERMANENTLY_BLOCKED = 'C400000204';

// The webview session has expired
export const WEBVIEW_UUID_EXPIRED = 'C406000000';

// The favorite accounts limit has exceeded
export const FAVORITE_LIMIT_EXCEEDED = 'C406000001';

// The id already exists
export const ID_ALREADY_EXISTS = 'C406000005';

// The id already exists
export const UNPROCESSABLE_ENTITY_BLOCKED_OPERATION = 'C422000000';

export const PERSONAL_MANAGER = 'PERSONAL_MANAGER';
export const BUSINESS_BANKING_MANAGER = 'BUSINESS_BANKING_MANAGER';
export const PRIVATE_BANKING_MANAGER = 'PRIVATE_BANKING_MANAGER';
export const DIGITAL_MANAGER = 'DIGITAL_MANAGER'; // GESTOR DIGITAL
export const MANAGEMENT_OFFICE = 'MANAGEMENT_OFFICE';

export const DIGITAL_MANAGER_CODE = '0234_8';
export const VACANT_MANAGER_CODE = '0234_9998'; // (Is never shown)
export const MANAGEMENT_OFFICE_CODE = '0234_9999';

export const NIF_CODE = 62;

export const AGENT_RELATIONS = {
	'0234_1': PERSONAL_MANAGER,
	'0234_2': PERSONAL_MANAGER,
	'0234_7': PERSONAL_MANAGER,
	'0234_9': PERSONAL_MANAGER, // GESTOR PERSONAL
	'0234_4': BUSINESS_BANKING_MANAGER,
	'0234_5': BUSINESS_BANKING_MANAGER, // GESTOR BANCA EMPRESA
	'0234_3': PRIVATE_BANKING_MANAGER,
	'0234_6': PRIVATE_BANKING_MANAGER,
	'0234_8': PRIVATE_BANKING_MANAGER, // GESTOR BANCA PRIVADA
	'0234_9999': MANAGEMENT_OFFICE, // OFICINA GESTORA
};

export const CTA_TYPE = {
	OPEN_INTERNAL: 'open_internal',
	OPEN_EXTERNAL: 'open_external',
	OPEN_FILE: 'open_file',
	ACCEPTANCE: 'acceptance',
	OPEN_FUNCTIONALITY: 'open_functionality',
};

// Constante de Provincias de Assisted Channels
export const PROVINCES = {
	'02': 'Albacete',
	'03': 'Alicante/Alacant',
	'04': 'Almería',
	'01': 'Araba/Álava',
	'33': 'Asturias',
	'05': 'Ávila',
	'06': 'Badajoz',
	'07': 'Balears, Illes',
	'08': 'Barcelona',
	'48': 'Bizkaia',
	'09': 'Burgos',
	'10': 'Cáceres',
	'11': 'Cádiz',
	'39': 'Cantabria',
	'12': 'Castellón/Castelló',
	'13': 'Ciudad Real',
	'14': 'Córdoba',
	'15': 'Coruña, A',
	'16': 'Cuenca',
	'20': 'Gipuzkoa',
	'17': 'Girona',
	'18': 'Granada',
	'19': 'Guadalajara',
	'21': 'Huelva',
	'22': 'Huesca',
	'23': 'Jaén',
	'24': 'León',
	'25': 'Lleida',
	'27': 'Lugo',
	'28': 'Madrid',
	'29': 'Málaga',
	'30': 'Murcia',
	'31': 'Navarra',
	'32': 'Ourense',
	'34': 'Palencia',
	'35': 'Palmas, Las',
	'36': 'Pontevedra',
	'26': 'Rioja, La',
	'37': 'Salamanca',
	'38': 'Santa Cruz de Tenerife',
	'40': 'Segovia',
	'41': 'Sevilla',
	'42': 'Soria',
	'43': 'Tarragona',
	'44': 'Teruel',
	'45': 'Toledo',
	'46': 'Valencia/València',
	'47': 'Valladolid',
	'49': 'Zamora',
	'50': 'Zaragoza',
	'51': 'Ceuta',
	'52': 'Melilla',
};

// Constante de Paises de Assisted Channels
export const COUNTRIES = {
	AFG: 'Afganistán',
	ALA: 'Åland, Islas',
	ALB: 'Albania',
	DEU: 'Alemania',
	AND: 'Andorra',
	AGO: 'Angola',
	AIA: 'Anguila',
	ATA: 'Antártida',
	ATG: 'Antigua y Barbuda',
	SAU: 'Arabia Saudita',
	DZA: 'Argelia',
	ARG: 'Argentina',
	ARM: 'Armenia',
	ABW: 'Aruba',
	AUS: 'Australia',
	AUT: 'Austria',
	AZE: 'Azerbaiyán',
	BHS: 'Bahamas (las)',
	BGD: 'Bangladesh',
	BRB: 'Barbados',
	BHR: 'Bahrein',
	BEL: 'Bélgica',
	BLZ: 'Belice',
	BEN: 'Benin',
	BMU: 'Bermudas',
	BLR: 'Belarús',
	BOL: 'Bolivia (Estado Plurinacional de)',
	BES: 'Bonaire, San Eustaquio y Saba',
	BIH: 'Bosnia y Herzegovina',
	BWA: 'Botswana',
	BRA: 'Brasil',
	BRN: 'Brunei Darussalam',
	BGR: 'Bulgaria',
	BFA: 'Burkina Faso',
	BDI: 'Burundi',
	BTN: 'Bhután',
	CPV: 'Cabo Verde',
	KHM: 'Camboya',
	CMR: 'Camerún',
	CAN: 'Canadá',
	QAT: 'Qatar',
	TCD: 'Chad',
	CHL: 'Chile',
	CHN: 'China',
	CYP: 'Chipre',
	COL: 'Colombia',
	COM: 'Comoras (las)',
	PRK: 'Corea (la República Popular Democrática de)',
	KOR: 'Corea (la República de)',
	CIV: "Côte d'Ivoire",
	CRI: 'Costa Rica',
	HRV: 'Croacia',
	CUB: 'Cuba',
	CUW: 'Curaçao',
	DNK: 'Dinamarca',
	DMA: 'Dominica',
	ECU: 'Ecuador',
	EGY: 'Egipto',
	SLV: 'El Salvador',
	ARE: 'Emiratos Árabes Unidos (los)',
	ERI: 'Eritrea',
	SVK: 'Eslovaquia',
	SVN: 'Eslovenia',
	ESP: 'España',
	USA: 'Estados Unidos de América (los)',
	EST: 'Estonia',
	ETH: 'Etiopía',
	PHL: 'Filipinas (las)',
	FIN: 'Finlandia',
	FJI: 'Fiji',
	FRA: 'Francia',
	GAB: 'Gabón',
	GMB: 'Gambia (la)',
	GEO: 'Georgia',
	GHA: 'Ghana',
	GIB: 'Gibraltar',
	GRD: 'Granada',
	GRC: 'Grecia',
	GRL: 'Groenlandia',
	GLP: 'Guadeloupe',
	GUM: 'Guam',
	GTM: 'Guatemala',
	GUF: 'Guayana Francesa',
	GGY: 'Guernsey',
	GIN: 'Guinea',
	GNB: 'Guinea Bissau',
	GNQ: 'Guinea Ecuatorial',
	GUY: 'Guyana',
	HTI: 'Haití',
	HND: 'Honduras',
	HKG: 'Hong Kong',
	HUN: 'Hungría',
	IND: 'India',
	IDN: 'Indonesia',
	IRQ: 'Iraq',
	IRN: 'Irán (República Islámica de)',
	IRL: 'Irlanda',
	BVT: 'Bouvet, Isla',
	IMN: 'Isla de Man',
	CXR: 'Navidad, Isla de',
	ISL: 'Islandia',
	CYM: 'Caimán, (las) Islas',
	CCK: 'Cocos / Keeling, (las) Islas',
	COK: 'Cook, (las) Islas',
	FRO: 'Feroe, (las) Islas',
	SGS: 'Georgia del Sur (la) y las Islas Sandwich del Sur',
	HMD: 'Heard (Isla) e Islas McDonald',
	FLK: 'Malvinas [Falkland], (las) Islas',
	MNP: 'Marianas del Norte, (las) Islas',
	MHL: 'Marshall, (las) Islas',
	PCN: 'Pitcairn',
	SLB: 'Salomón, Islas',
	TCA: 'Turcas y Caicos, (las) Islas',
	UMI: 'Islas Ultramarinas Menores de los Estados Unidos (la)',
	VGB: 'Vírgenes británicas, Islas',
	VIR: 'Vírgenes de los Estados Unidos, Islas',
	ISR: 'Israel',
	ITA: 'Italia',
	JAM: 'Jamaica',
	JPN: 'Japón',
	JEY: 'Jersey',
	JOR: 'Jordania',
	KAZ: 'Kazajstán',
	KEN: 'Kenya',
	KGZ: 'Kirguistán',
	KIR: 'Kiribati',
	KWT: 'Kuwait',
	LAO: 'Lao, (la) República Democrática Popular',
	LSO: 'Lesotho',
	LVA: 'Letonia',
	LBN: 'Líbano',
	LBR: 'Liberia',
	LBY: 'Libia',
	LIE: 'Liechtenstein',
	LTU: 'Lituania',
	LUX: 'Luxemburgo',
	MAC: 'Macao',
	MKD: 'Macedonia (la ex República Yugoslava de)',
	MDG: 'Madagascar',
	MYS: 'Malasia',
	MWI: 'Malawi',
	MDV: 'Maldivas',
	MLI: 'Malí',
	MLT: 'Malta',
	MAR: 'Marruecos',
	MTQ: 'Martinique',
	MUS: 'Mauricio',
	MRT: 'Mauritania',
	MYT: 'Mayotte',
	MEX: 'México',
	FSM: 'Micronesia (Estados Federados de)',
	MDA: 'Moldova (la República de)',
	MCO: 'Mónaco',
	MNG: 'Mongolia',
	MNE: 'Montenegro',
	MSR: 'Montserrat',
	MOZ: 'Mozambique',
	MMR: 'Myanmar',
	NAM: 'Namibia',
	NRU: 'Nauru',
	NPL: 'Nepal',
	NIC: 'Nicaragua',
	NER: 'Níger (el)',
	NGA: 'Nigeria',
	NIU: 'Niue',
	NFK: 'Norfolk, Isla',
	NOR: 'Noruega',
	NCL: 'Nueva Caledonia',
	NZL: 'Nueva Zelandia',
	OMN: 'Omán',
	NLD: 'Países Bajos (los)',
	PAK: 'Pakistán',
	PLW: 'Palau',
	PSE: 'Palestina, Estado de',
	PAN: 'Panamá',
	PNG: 'Papua Nueva Guinea',
	PRY: 'Paraguay',
	PER: 'Perú',
	PYF: 'Polinesia Francesa',
	POL: 'Polonia',
	PRT: 'Portugal',
	PRI: 'Puerto Rico',
	GBR: 'Reino Unido de Gran Bretaña e Irlanda del Norte (el)',
	ESH: 'Sahara Occidental',
	CAF: 'República Centroafricana (la)',
	CZE: 'Chequia',
	COG: 'Congo (el)',
	COD: 'Congo (la República Democrática del)',
	DOM: 'Dominicana, (la) República',
	REU: 'Reunión',
	RWA: 'Rwanda',
	ROU: 'Rumania',
	RUS: 'Rusia, (la) Federación de',
	WSM: 'Samoa',
	ASM: 'Samoa Americana',
	BLM: 'Saint Barthélemy',
	KNA: 'Saint Kitts y Nevis',
	SMR: 'San Marino',
	MAF: 'Saint Martin (parte francesa)',
	SPM: 'San Pedro y Miquelón',
	VCT: 'San Vicente y las Granadinas',
	SHN: 'Santa Helena, Ascensión y Tristán de Acuña',
	LCA: 'Santa Lucía',
	STP: 'Santo Tomé y Príncipe',
	SEN: 'Senegal',
	SRB: 'Serbia',
	SYC: 'Seychelles',
	SLE: 'Sierra leona',
	SGP: 'Singapur',
	SXM: 'Sint Maarten (parte neerlandesa)',
	SYR: 'República Árabe Siria',
	SOM: 'Somalia',
	LKA: 'Sri Lanka',
	SWZ: 'Swazilandia',
	ZAF: 'Sudáfrica',
	SDN: 'Sudán (el)',
	SSD: 'Sudán del Sur',
	SWE: 'Suecia',
	CHE: 'Suiza',
	SUR: 'Suriname',
	SJM: 'Svalbard y Jan Mayen',
	THA: 'Tailandia',
	TWN: 'Taiwán (Provincia de China)',
	TZA: 'Tanzania, República Unida de',
	TJK: 'Tayikistán',
	IOT: 'Territorio Británico del Océano Índico (el)',
	ATF: 'Tierras Australes Francesas (las)',
	TLS: 'Timor-Leste',
	TGO: 'Togo',
	TKL: 'Tokelau',
	TON: 'Tonga',
	TTO: 'Trinidad y Tobago',
	TUN: 'Túnez',
	TKM: 'Turkmenistán',
	TUR: 'Turquía',
	TUV: 'Tuvalu',
	UKR: 'Ucrania',
	UGA: 'Uganda',
	URY: 'Uruguay',
	UZB: 'Uzbekistán',
	VUT: 'Vanuatu',
	VAT: 'Santa Sede (la)',
	VEN: 'Venezuela (República Bolivariana de)',
	VNM: 'Viet Nam',
	WLF: 'Wallis y Futuna',
	YEM: 'Yemen',
	DJI: 'Djibouti',
	ZMB: 'Zambia',
	ZWE: 'Zimbabwe',
};

// Constante de Código de Paises en CBNK
export const COUNTRY_CODES = [
	{ code: '660', name: 'Afganistan', iso: 'AF' },
	{ code: '070', name: 'Albania', iso: 'AL' },
	{ code: '004', name: 'Alemania', iso: 'DE' },
	{ code: '043', name: 'Andorra', iso: 'AD' },
	{ code: '330', name: 'Angola', iso: 'AO' },
	{ code: '478', name: 'Ant Neerlandesas Hasta 28/02/11', iso: 'AN' },
	{ code: '891', name: 'Antartida', iso: 'AQ' },
	{ code: '459', name: 'Antigua Y Barbuda', iso: 'AG' },
	{ code: '632', name: 'Arabia Saudita', iso: 'SA' },
	{ code: '027', name: 'Archipielago De Svalbard', iso: 'SJ' },
	{ code: '208', name: 'Argelia', iso: 'DZ' },
	{ code: '528', name: 'Argentina', iso: 'AR' },
	{ code: '077', name: 'Armenia', iso: 'AM' },
	{ code: '474', name: 'Aruba', iso: 'AW' },
	{ code: '800', name: 'Australia', iso: 'AU' },
	{ code: '038', name: 'Austria', iso: 'AT' },
	{ code: '078', name: 'Azerbaijan', iso: 'AZ' },
	{ code: '453', name: 'Bahamas', iso: 'BS' },
	{ code: '640', name: 'Bahrein', iso: 'BH' },
	{ code: '930', name: 'Banco Central Europeo', iso: 'XB' },
	{ code: '666', name: 'Bangladesh', iso: 'BD' },
	{ code: '469', name: 'Barbados', iso: 'BB' },
	{ code: '017', name: 'Belgica', iso: 'BE' },
	{ code: '421', name: 'Belice', iso: 'BZ' },
	{ code: '284', name: 'Benin', iso: 'BJ' },
	{ code: '413', name: 'Bermudas', iso: 'BM' },
	{ code: '675', name: 'Bhutan', iso: 'BT' },
	{ code: '073', name: 'Bielorrusia', iso: 'BY' },
	{ code: '516', name: 'Bolivia', iso: 'BO' },
	{ code: '477', name: 'Bonaire, San Eustaquio Y Saba', iso: 'BQ' },
	{ code: '093', name: 'Bosnia-Herzegovina', iso: 'BA' },
	{ code: '391', name: 'Botswana', iso: 'BW' },
	{ code: '892', name: 'Bouvet, Isla', iso: 'BV' },
	{ code: '508', name: 'Brasil', iso: 'BR' },
	{ code: '703', name: 'Brunei', iso: 'BN' },
	{ code: '068', name: 'Bulgaria', iso: 'BG' },
	{ code: '236', name: 'Burkina-Faso (Alto Volta)', iso: 'BF' },
	{ code: '328', name: 'Burundi', iso: 'BI' },
	{ code: '302', name: 'Camerun', iso: 'CM' },
	{ code: '404', name: 'Canada', iso: 'CA' },
	{ code: '512', name: 'Chile', iso: 'CL' },
	{ code: '720', name: 'China', iso: 'CN' },
	{ code: '600', name: 'Chipre', iso: 'CY' },
	{ code: '045', name: 'Ciudad Del Vaticano', iso: 'VA' },
	{ code: '166', name: 'Cocos, Islas', iso: 'CC' },
	{ code: '480', name: 'Colombia', iso: 'CO' },
	{ code: '375', name: 'Comores/Gran Comores/Anjouan/Micheli', iso: 'KM' },
	{ code: '318', name: 'Congo', iso: 'CG' },
	{ code: '724', name: 'Corea Del Norte', iso: 'KP' },
	{ code: '728', name: 'Corea Del Sur', iso: 'KR' },
	{ code: '272', name: 'Costa De Marfil', iso: 'CI' },
	{ code: '436', name: 'Costa Rica', iso: 'CR' },
	{ code: '092', name: 'Croacia', iso: 'HR' },
	{ code: '448', name: 'Cuba', iso: 'CU' },
	{ code: '475', name: 'Curaçao', iso: 'CW' },
	{ code: '008', name: 'Dinamarca', iso: 'DK' },
	{ code: '338', name: 'Djibouti', iso: 'DJ' },
	{ code: '460', name: 'Dominica', iso: 'DM' },
	{ code: '500', name: 'Ecuador', iso: 'EC' },
	{ code: '220', name: 'Egipto', iso: 'EG' },
	{ code: '428', name: 'El Salvador', iso: 'SV' },
	{ code: '647', name: 'Emiratos Arabes Unidos', iso: 'AE' },
	{ code: '336', name: 'Eritrea', iso: 'ER' },
	{ code: '091', name: 'Eslovenia', iso: 'SI' },
	{ code: '011', name: 'España', iso: 'ES' },
	{ code: '400', name: 'Estados Unidos De America', iso: 'US' },
	{ code: '053', name: 'Estonia', iso: 'EE' },
	{ code: '334', name: 'Etiopia', iso: 'ET' },
	{ code: '823', name: 'Federacion De Estados De Micronesia', iso: 'FM' },
	{ code: '815', name: 'Fiji', iso: 'FJ' },
	{ code: '708', name: 'Filipinas', iso: 'PH' },
	{ code: '032', name: 'Finlandia', iso: 'FI' },
	{ code: '001', name: 'Francia', iso: 'FR' },
	{ code: '314', name: 'Gabon', iso: 'GA' },
	{ code: '252', name: 'Gambia', iso: 'GM' },
	{ code: '076', name: 'Georgia', iso: 'GE' },
	{ code: '893', name: 'Georgia Del Sur', iso: 'GS' },
	{ code: '276', name: 'Ghana', iso: 'GH' },
	{ code: '044', name: 'Gibraltar', iso: 'GI' },
	{ code: '473', name: 'Granada', iso: 'GD' },
	{ code: '009', name: 'Grecia', iso: 'GR' },
	{ code: '406', name: 'Groenlandia', iso: 'GL' },
	{ code: '458', name: 'Guadalupe', iso: 'GP' },
	{ code: '316', name: 'Guam', iso: 'GU' },
	{ code: '416', name: 'Guatemala', iso: 'GT' },
	{ code: '496', name: 'Guayana Francesa', iso: 'GF' },
	{ code: '831', name: 'Guernsey', iso: 'GG' },
	{ code: '260', name: 'Guinea', iso: 'GN' },
	{ code: '310', name: 'Guinea Ecuatorial', iso: 'GQ' },
	{ code: '257', name: 'Guinea-Bissau', iso: 'GW' },
	{ code: '488', name: 'Guyana', iso: 'GY' },
	{ code: '452', name: 'Haiti', iso: 'HT' },
	{ code: '835', name: 'Heard Y McDonald, Islas', iso: 'HM' },
	{ code: '424', name: 'Honduras', iso: 'HN' },
	{ code: '740', name: 'Hong Kong', iso: 'HK' },
	{ code: '064', name: 'Hungria', iso: 'HU' },
	{ code: '664', name: 'India', iso: 'IN' },
	{ code: '700', name: 'Indonesia', iso: 'ID' },
	{ code: '910', name: 'Instituciones de la Unión Europea', iso: 'XU' },
	{ code: '616', name: 'Irán', iso: 'IR' },
	{ code: '612', name: 'Irak', iso: 'IQ' },
	{ code: '007', name: 'Irlanda', iso: 'IE' },
	{ code: '104', name: 'Isla de Man', iso: 'IM' },
	{ code: '024', name: 'Islandia', iso: 'IS' },
	{ code: '103', name: 'Islas Anglonormandas (Guernsey & Jersey)', iso: 'XC' },
	{ code: '463', name: 'Islas Caimán', iso: 'KY' },
	{ code: '107', name: 'Islas Cook', iso: 'CK' },
	{ code: '041', name: 'Islas Feroe', iso: 'FO' },
	{ code: '667', name: 'Islas Maldivas', iso: 'MV' },
	{ code: '529', name: 'Islas Malvinas (Falklands)', iso: 'FK' },
	{ code: '820', name: 'Islas Marianas del Norte', iso: 'MP' },
	{ code: '824', name: 'Islas Marshall', iso: 'MH' },
	{ code: '806', name: 'Islas Salomón', iso: 'SB' },
	{ code: '454', name: 'Islas Turquesas y Caicos', iso: 'TC' },
	{ code: '468', name: 'Islas Vírgenes Británicas', iso: 'VG' },
	{ code: '457', name: 'Islas Vírgenes de los Estados Unidos', iso: 'VI' },
	{ code: '811', name: 'Islas Wallis/Futuna (Inc. I. Alori)', iso: 'WF' },
	{ code: '624', name: 'Israel', iso: 'IL' },
	{ code: '005', name: 'Italia', iso: 'IT' },
	{ code: '464', name: 'Jamaica', iso: 'JM' },
	{ code: '732', name: 'Japón', iso: 'JP' },
	{ code: '628', name: 'Jordania', iso: 'JO' },
	{ code: '696', name: 'Camboya', iso: 'KH' },
	{ code: '079', name: 'Kazajistán', iso: 'KZ' },
	{ code: '346', name: 'Kenia', iso: 'KE' },
	{ code: '083', name: 'Kirguistán', iso: 'KG' },
	{ code: '812', name: 'Kiribati', iso: 'KI' },
	{ code: '997', name: 'Kosovo', iso: 'XK' },
	{ code: '636', name: 'Kuwait', iso: 'KW' },
	{ code: '684', name: 'Laos', iso: 'LA' },
	{ code: '395', name: 'Lesoto', iso: 'LS' },
	{ code: '054', name: 'Letonia', iso: 'LV' },
	{ code: '604', name: 'Líbano', iso: 'LB' },
	{ code: '268', name: 'Liberia', iso: 'LR' },
	{ code: '216', name: 'Libia', iso: 'LY' },
	{ code: '037', name: 'Liechtenstein', iso: 'LI' },
	{ code: '055', name: 'Lituania', iso: 'LT' },
	{ code: '018', name: 'Luxemburgo', iso: 'LU' },
	{ code: '743', name: 'Macao', iso: 'MO' },
	{ code: '096', name: 'Macedonia', iso: 'MK' },
	{ code: '370', name: 'Madagascar', iso: 'MG' },
	{ code: '701', name: 'Malasia', iso: 'MY' },
	{ code: '386', name: 'Malawi', iso: 'MW' },
	{ code: '232', name: 'Mali', iso: 'ML' },
	{ code: '046', name: 'Malta', iso: 'MT' },
	{ code: '204', name: 'Marruecos', iso: 'MA' },
	{ code: '462', name: 'Martinica', iso: 'MQ' },
	{ code: '373', name: 'Mauricio', iso: 'MU' },
	{ code: '228', name: 'Mauritania', iso: 'MR' },
	{ code: '377', name: 'Mayotte, Gran Tierra y Pamani', iso: 'YT' },
	{ code: '412', name: 'México', iso: 'MX' },
	{ code: '074', name: 'Moldavia', iso: 'MD' },
	{ code: '101', name: 'Mónaco', iso: 'MC' },
	{ code: '716', name: 'Mongolia', iso: 'MN' },
	{ code: '095', name: 'Montenegro', iso: 'ME' },
	{ code: '470', name: 'Montserrat', iso: 'MS' },
	{ code: '366', name: 'Mozambique', iso: 'MZ' },
	{ code: '676', name: 'Myanmar (Antigua Birmania)', iso: 'MM' },
	{ code: '389', name: 'Namibia', iso: 'NA' },
	{ code: '803', name: 'Nauru', iso: 'NR' },
	{ code: '834', name: 'Navidad, Isla', iso: 'CX' },
	{ code: '672', name: 'Nepal', iso: 'NP' },
	{ code: '432', name: 'Nicaragua', iso: 'NI' },
	{ code: '240', name: 'Níger', iso: 'NE' },
	{ code: '288', name: 'Nigeria', iso: 'NG' },
	{ code: '570', name: 'Niue', iso: 'NU' },
	{ code: '836', name: 'Norfolk, Islas', iso: 'NF' },
	{ code: '028', name: 'Noruega', iso: 'NO' },
	{ code: '809', name: 'Nueva Caledonia', iso: 'NC' },
	{ code: '804', name: 'Nueva Zelanda', iso: 'NZ' },
	{ code: '810', name: 'Oceania Americana', iso: 'XA' },
	{ code: '802', name: 'Oceania Australiana', iso: 'XO' },
	{ code: '814', name: 'Oceania Neozelandesa', iso: 'XZ' },
	{ code: '649', name: 'Omán', iso: 'OM' },
	{ code: '921', name: 'Organismos Internacionales', iso: 'XI' },
	{ code: '920', name: 'Organismos Internacionales no U.E.', iso: 'XN' },
	{ code: '003', name: 'Países Bajos', iso: 'NL' },
	{ code: '958', name: 'Países y Territorios no Determinado', iso: 'QU' },
	{ code: '662', name: 'Pakistán', iso: 'PK' },
	{ code: '825', name: 'Palau', iso: 'PW' },
	{ code: '442', name: 'Panamá', iso: 'PA' },
	{ code: '801', name: 'Papúa Nueva Guinea', iso: 'PG' },
	{ code: '520', name: 'Paraguay', iso: 'PY' },
	{ code: '504', name: 'Perú', iso: 'PE' },
	{ code: '813', name: 'Pitcairn (Inc. I. Henderson/Duciet Ol)', iso: 'PN' },
	{ code: '822', name: 'Polinesia Francesa', iso: 'PF' },
	{ code: '060', name: 'Polonia', iso: 'PL' },
	{ code: '010', name: 'Portugal', iso: 'PT' },
	{ code: '630', name: 'Puerto Rico', iso: 'PR' },
	{ code: '644', name: 'Catar', iso: 'QA' },
	{ code: '890', name: 'Regiones Polares', iso: 'XR' },
	{ code: '006', name: 'Reino Unido', iso: 'GB' },
	{ code: '306', name: 'República Centro Africana', iso: 'CF' },
	{ code: '061', name: 'República Checa', iso: 'CZ' },
	{ code: '247', name: 'República de Cabo Verde', iso: 'CV' },
	{ code: '322', name: 'República Democrática del Congo', iso: 'CD' },
	{ code: '456', name: 'República Dominicana', iso: 'DO' },
	{ code: '063', name: 'Republica Eslovaca', iso: 'SK' },
	{ code: '372', name: 'Reunion', iso: 'RE' },
	{ code: '066', name: 'Rumania', iso: 'RO' },
	{ code: '075', name: 'Rusia', iso: 'RU' },
	{ code: '324', name: 'Rwanda', iso: 'RW' },
	{ code: '016', name: 'Samoa Americana', iso: 'AS' },
	{ code: '819', name: 'Samoa Occidental', iso: 'WS' },
	{ code: '449', name: 'San Cristobal y Nevis', iso: 'KN' },
	{ code: '047', name: 'San Marino', iso: 'SM' },
	{ code: '408', name: 'San Pedro y Miquelon', iso: 'PM' },
	{ code: '467', name: 'San Vicente e Islas Granadinas', iso: 'VC' },
	{ code: '329', name: 'Santa Helena y Dependencias', iso: 'SH' },
	{ code: '465', name: 'Santa Lucia', iso: 'LC' },
	{ code: '311', name: 'Santo Tome y Principe', iso: 'ST' },
	{ code: '248', name: 'Senegal', iso: 'SN' },
	{ code: '094', name: 'Serbia', iso: 'RS' },
	{ code: '688', name: 'Servia y Montenegro (Hasta 01.01.07)', iso: 'CS' },
	{ code: '355', name: 'Seychelles', iso: 'SC' },
	{ code: '264', name: 'Sierra Leona', iso: 'SL' },
	{ code: '706', name: 'Singapur', iso: 'SG' },
	{ code: '663', name: 'Sint Maarten', iso: 'SX' },
	{ code: '608', name: 'Siria', iso: 'SY' },
	{ code: '342', name: 'Somalia', iso: 'SO' },
	{ code: '669', name: 'Sri Lanka', iso: 'LK' },
	{ code: '388', name: 'Sudafrica', iso: 'ZA' },
	{ code: '224', name: 'Sudan', iso: 'SD' },
	{ code: '730', name: 'Sudan del Sur', iso: 'SS' },
	{ code: '030', name: 'Suecia', iso: 'SE' },
	{ code: '039', name: 'Suiza', iso: 'CH' },
	{ code: '492', name: 'Surinam', iso: 'SR' },
	{ code: '393', name: 'Swazilandia', iso: 'SZ' },
	{ code: '736', name: 'Taiwan', iso: 'TW' },
	{ code: '082', name: 'Tajikistan', iso: 'TJ' },
	{ code: '352', name: 'Tanzania', iso: 'TZ' },
	{ code: '244', name: 'Chad', iso: 'TD' },
	{ code: '357', name: 'Territorio Britanico del Oceano Indico', iso: 'IO' },
	{ code: '625', name: 'Territorio Palestino Ocupado', iso: 'PS' },
	{ code: '680', name: 'Tailandia', iso: 'TH' },
	{ code: '894', name: 'Tierras Australes Francesas', iso: 'TF' },
	{ code: '702', name: 'Timor Leste', iso: 'TL' },
	{ code: '280', name: 'Togo', iso: 'TG' },
	{ code: '839', name: 'Tokelau, Islas', iso: 'TK' },
	{ code: '817', name: 'Tonga', iso: 'TO' },
	{ code: '472', name: 'Trinidad y Tobago', iso: 'TT' },
	{ code: '212', name: 'Tunez', iso: 'TN' },
	{ code: '080', name: 'Turkmenistan', iso: 'TM' },
	{ code: '052', name: 'Turquia', iso: 'TR' },
	{ code: '807', name: 'Tuvalu', iso: 'TV' },
	{ code: '072', name: 'Ucrania', iso: 'UA' },
	{ code: '350', name: 'Uganda', iso: 'UG' },
	{ code: '524', name: 'Uruguay', iso: 'UY' },
	{ code: '081', name: 'Uzbekistan', iso: 'UZ' },
	{ code: '816', name: 'Vanuatu', iso: 'VU' },
	{ code: '484', name: 'Venezuela', iso: 'VE' },
	{ code: '690', name: 'Vietnam', iso: 'VN' },
	{ code: '653', name: 'Yemen', iso: 'YE' },
	{ code: '378', name: 'Zambia', iso: 'ZM' },
	{ code: '382', name: 'Zimbabwe', iso: 'ZW' },
];

// Tipos de estados en Assisted Channels
export const STATES = {
	0: 'Onboarding OK',
	1: 'Onboarding KO',
	2: 'Contratación pendiente',
	3: 'Contratación en proceso',
	4: 'Contratación OK',
	5: 'Contratación KO',
	6: 'Alta OK',
};

// Tipos de motivos en Assisted Channels
export const REASONS = {
	0: 'Onboarding OK',
	1: 'Caída onboarding',
	2: 'Evidencias KO',
	3: 'AML KO - Listas Negras UE',
	4: 'Pendiente Banca Electrónica',
	5: 'Pendiente tarjeta',
	6: 'Pendiente firma',
	7: 'Pendiente activación',
	8: 'Cliente KO',
	9: 'Producto KO',
	10: 'Banca Electrónica KO',
	11: 'Tarjeta KO',
	12: 'Firma KO',
	13: 'Activación KO',
	14: 'Pendiente activación BE',
	15: 'OTP KO',
	16: 'Documentación pendiente',
	17: 'Pendiente activación tarjeta',
	18: 'Contratación desestimada',
	20: 'Marca OCIC',
	21: 'PRP',
	22: 'Riesgo PBC alto',
	23: 'Pendiente contratación Core',
	24: 'Error Alta en el Core',
	25: 'Pendiente listas negras',
};

export const TYPES = {
	AV: 'Avenida',
	CL: 'Calle',
	CK: 'Callejón',
	CM: 'Camino',
	CR: 'Carretera',
	PS: 'Paseo',
	PJ: 'Pasaje',
	PZ: 'Plaza',
	RB: 'Rambla',
	RD: 'Ronda',
};

export const DAYS = {
	1: '1',
	2: '2',
	3: '3',
	4: '4',
	5: '5',
	6: '6',
	7: '7',
	8: '8',
	9: '9',
	10: '10',
	11: '11',
	12: '12',
	13: '13',
	14: '14',
	15: '15',
	16: '16',
	17: '17',
	18: '18',
	19: '19',
	20: '20',
	21: '21',
	22: '22',
	23: '23',
	24: '24',
	25: '25',
	26: '26',
	27: '27',
	28: '28',
	29: '29',
	30: '30',
	31: '31',
};

export const MONTHS = {
	0: 'Enero',
	1: 'Febrero',
	2: 'Marzo',
	3: 'Abril',
	4: 'Mayo',
	5: 'Junio',
	6: 'Julio',
	7: 'Agosto',
	8: 'Septiembre',
	9: 'Octubre',
	10: 'Noviembre',
	11: 'Diciembre',
};

export const ORIGINS = {
	0: 'Onboarding',
	1: 'Alta a distancia',
};

//Verticlals translations
export const VERTICALS_T = {
	1: 'ONBOARDING.VERTICAL_ENG',
	2: 'ONBOARDING.VERTICAL_SAL',
};

//Collectives translations
export const COLLECTIVES_T = {
	1: 'ONBOARDING.COLLECTIVE.CIVIL_ENGINEERING_ICCP',
	2: 'ONBOARDING.COLLECTIVE.PHARMACY',
	3: 'ONBOARDING.COLLECTIVE.COMPUTER_ENGINEERING',
	4: 'ONBOARDING.COLLECTIVE.MEDICINE',
	5: 'ONBOARDING.COLLECTIVE.INDUSTRIAL_ENGINEERING',
	6: 'ONBOARDING.COLLECTIVE.FOOD_SCIENCE_AND_TECHNOLOGY',
	7: 'ONBOARDING.COLLECTIVE.MINING_ENGINEERING',
	8: 'ONBOARDING.COLLECTIVE.TEACHERS_AND_PROFESSORS',
	9: 'ONBOARDING.COLLECTIVE.NAVAL_ENGINEERING',
	10: 'ONBOARDING.COLLECTIVE.NURSING',
	11: 'ONBOARDING.COLLECTIVE.TELECOMMUNICATION_SYSTEMS_ENGINEERING',
	12: 'ONBOARDING.COLLECTIVE.PHYSIOTHERAPY',
	13: 'ONBOARDING.COLLECTIVE.AGRONOMIC_FOOD_AND_BIOSYSTEMS_ENGINEERING',
	14: 'ONBOARDING.COLLECTIVE.SPEECH_THERAPY',
	15: 'ONBOARDING.COLLECTIVE.FORESTRY_ENVIRONMENTAL_AND_NATURAL_RESOURCES_ENGINEERING',
	16: 'ONBOARDING.COLLECTIVE.NUTRITION_AND_DIETETICS',
	17: 'ONBOARDING.COLLECTIVE.AERONAUTICAL_AND_SPACE_ENGINEERING',
	18: 'ONBOARDING.COLLECTIVE.DENTISTRY',
	19: 'ONBOARDING.COLLECTIVE.ARCHITECTURE_BUILDING_ENGINEERING',
	20: 'ONBOARDING.COLLECTIVE.OPTICS_AND_OPTOMETRY',
	21: 'ONBOARDING.COLLECTIVE.LAW',
	22: 'ONBOARDING.COLLECTIVE.PSYCHOLOGY',
	23: 'ONBOARDING.COLLECTIVE.ECONOMICS',
	24: 'ONBOARDING.COLLECTIVE.VETERINARY_MEDICINE',
	25: 'ONBOARDING.COLLECTIVE.TEACHERS_AND_PROFESSORS',
	26: 'ONBOARDING.COLLECTIVE.OTHER_HEALTH_FIELDS',
	27: 'ONBOARDING.COLLECTIVE.OTHER_ENGINEERING_FIELDS',
	998: 'ONBOARDING.COLLECTIVE.OTHER_ESSENTIAL_GROUPS',
	999: 'ONBOARDING.COLLECTIVE.OTHER_ESSENTIAL_GROUPS',
};

// Spaces in campaigns
export const SPACES = {
	1: 'CAMPAIGN.DETAIL.COMUNICATION.SPACES.PRELOGIN',
	2: 'CAMPAIGN.DETAIL.COMUNICATION.SPACES.POSTLOGIN',
	3: 'CAMPAIGN.DETAIL.COMUNICATION.SPACES.GLOBAL_POSITION_BANNER',
};

// Companies in campaigns
export const COMPANIES = {
	BC: 'CBNK',
	FA: 'Mediación Seguros',
};

// Channel types in campaigns
export const CHANNELS = {
	IOS: 'IOS',
	ANDROID: 'ANDROID',
	WEB: 'WEB',
};

// Publication types in campaigns
export const PUBLICATION_TYPES = {
	1: 'CAMPAIGN.DETAIL.COMUNICATION.PUBLICATION_TYPES.REGULATORY',
	2: 'CAMPAIGN.DETAIL.COMUNICATION.PUBLICATION_TYPES.OPERATIVE',
	3: 'CAMPAIGN.DETAIL.COMUNICATION.PUBLICATION_TYPES.COMERCIAL',
	4: 'CAMPAIGN.DETAIL.COMUNICATION.PUBLICATION_TYPES.LEARNING',
};

// Publication types in campaigns
export const CTA_TYPES = {
	1: 'CAMPAIGN.DETAIL.COMUNICATION.CTA_TYPES.OPEN_INTERNAL',
	2: 'CAMPAIGN.DETAIL.COMUNICATION.CTA_TYPES.OPEN_EXTERNAL',
	3: 'CAMPAIGN.DETAIL.COMUNICATION.CTA_TYPES.OPEN_FILE',
	4: 'CAMPAIGN.DETAIL.COMUNICATION.CTA_TYPES.ACCEPTANCE',
};

// Publication types in campaigns with get response
export const CTA_TYPES_RESPONSE = {
	open_internal: 'CAMPAIGN.DETAIL.COMUNICATION.CTA_TYPES.OPEN_INTERNAL',
	open_external: 'CAMPAIGN.DETAIL.COMUNICATION.CTA_TYPES.OPEN_EXTERNAL',
	open_file: 'CAMPAIGN.DETAIL.COMUNICATION.CTA_TYPES.OPEN_FILE',
	acceptance: 'CAMPAIGN.DETAIL.COMUNICATION.CTA_TYPES.ACCEPTANCE',
};

// Campaign types in outbounds campaigns
export const CAMPAIGN_MESSAGE_TYPES = {
	operational: 'CAMPAIGN.MESSAGE_TYPE.OPERATIONAL',
	commercial: 'CAMPAIGN.MESSAGE_TYPE.COMERCIAL',
	marketing: 'CAMPAIGN.MESSAGE_TYPE.MARKETING',
};

// Currency types in transfers
export const CURRENCIES = [
	{ code: '036', id: 'AUD', name: 'Dolar australiano' },
	{ code: '048', id: 'BHD', name: 'Dinar de barheim' },
	{ code: '100', id: 'BGN', name: 'Lev bulgaro' },
	{ code: '124', id: 'CAD', name: 'Dolar canadiense' },
	{ code: '191', id: 'HRK', name: 'Kuna croata' },
	{ code: '203', id: 'CZK', name: 'Corona checa' },
	{ code: '208', id: 'DKK', name: 'Corona danesa' },
	{ code: '248', id: 'HUF', name: 'Forint hungaro' },
	{ code: '344', id: 'HKD', name: 'Dolar de hong kong' },
	{ code: '376', id: 'ILS', name: 'Shekel israeli' },
	{ code: '392', id: 'JPY', name: 'Yen japones' },
	{ code: '400', id: 'JOD', name: 'Dinar de jordan' },
	{ code: '414', id: 'KWD', name: 'Dinar kuwaiti' },
	{ code: '484', id: 'MXN', name: 'Nuevo peso mejicano' },
	{ code: '504', id: 'MAD', name: 'Dirham marroqui' },
	{ code: '554', id: 'NZD', name: 'Dolar neozelandes' },
	{ code: '578', id: 'NOK', name: 'Corona noruega' },
	{ code: '616', id: 'PLN', name: 'Nuevo zloty polaco' },
	{ code: '634', id: 'QAR', name: 'Rial de qatar' },
	{ code: '642', id: 'RON', name: 'Leu rumano' },
	{ code: '682', id: 'SAR', name: 'Royal saudi' },
	{ code: '702', id: 'SGD', name: 'Dolar de singapur' },
	{ code: '710', id: 'ZAR', name: 'Rand sudafricano' },
	{ code: '752', id: 'SEK', name: 'Corona sueca' },
	{ code: '756', id: 'CHF', name: 'Franco suizo' },
	{ code: '784', id: 'AED', name: 'Dirham de union de emiratos arabes' },
	{ code: '788', id: 'TND', name: 'Dinar tunecino' },
	{ code: '826', id: 'GBP', name: 'Libra esterlina' },
	{ code: '840', id: 'USD', name: 'Dolar usa' },
	{ code: '949', id: 'TRY', name: 'Nueva lira turca' },
	{ code: '978', id: 'EUR', name: 'Euro' },
];
